export default "__VITE_ASSET__BdvfTgCt__"